'use client';
import React from 'react';

// Using a simple custom toast system to avoid external dependencies
// If sonner is added: import { Toaster } from 'sonner';
export default function ToastProvider() {
  return null;
}